import { createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'

import { useSignOutWithBootstrapPurge } from '@/features/auth'

export const Route = createFileRoute('/_auth/sign-out')({
  component: SignOutRoute
})

function SignOutRoute() {
  const { signOut } = useSignOutWithBootstrapPurge()

  useEffect(() => {
    signOut({ callbackUrl: '/sign-in' })
  }, [signOut])

  return null
}
